import { UserStyles } from '@chegg-wt/core/utils/userStyles'
import { styleIdSet } from '../constants/styleList'
import { urlStyleToIdMap } from '../server/utils/redirect'

/**
 * Object KEY is ALIAS
 * Object VALUE is STYLE_ID
 */
export const AliasToStyleIdMap = {
  ama: 'american-medical-association',
  apa6: 'apa',
  turabian: 'turabian-fullnote-bibliography',
  chicago: 'chicago-17-fullnote-bibliography',
  harvard: 'harvard1',
} as const

export const footnoteStyleIds = new Set([
  'turabian-fullnote-bibliography',
  'Turabian-9th-edition-Notes-Bib',
  'chicago-17-fullnote-bibliography',
  'chicago-note-biblio-no-ibid',
  'chicago-fullnote-bibliography',
  'chicago-fullnote-bibliography-fr',
  'chicago-fullnote-bibliography-no-ibid',
])

// mapping done bc of getUrlStyle map
export const popularStyles: Record<string, [string, string]> = {
  apa: ['APA6', 'American Psychological Association 6th edition'],
  apa7: ['APA', 'American Psychological Association 7th edition'],
  apa6: ['APA6', 'American Psychological Association 6th edition'],
  mla: ['MLA', 'Modern Language Association 9th edition'],
  mla9: ['MLA', 'Modern Language Association 9th edition'],
  mla8: ['MLA8', 'Modern Language Association 8th edition'],
  mla7: ['MLA7', 'Modern Language Association 7th edition'],
  harvard: ['Harvard', 'Harvard Reference format 1 (author-date)'],
  harvard1: ['Harvard', 'Harvard Reference format 1 (author-date)'],
  chicago: ['Chicago', 'Chicago Manual of Style 17th edition (note-bib)'],
  'chicago-17-fullnote-bibliography': [
    'Chicago',
    'Chicago Manual of Style 17th edition (note-bib)',
  ],
}

// primary seo styles
export const primaryStyles = new Set([
  'american-chemical-society',
  'american-medical-association',
  'american-political-science-association',
  'american-society-of-civil-engineers',
  'american-sociological-association',
  'apa',
  'apa7',
  'bibtex',
  'bluebook-law-review',
  'ieee',
  'mla',
  'mla7',
  'mla8',
  'mla9',
  'nature',
  'oscola',
  'turabian-fullnote-bibliography',
  'vancouver',
  'apa-5th-edition',
  'chicago-17-fullnote-bibliography',
  'chicago-17-author-date',
  'council-of-science-editors',
  'harvard1',
  'modern-humanities-research-association',
])

export const aliasFootnoteStyleIds = new Set(['turabian', 'chicago'])

export const styleIdToAlias = (styleId: string): string =>
  Object.keys(AliasToStyleIdMap).find((key) => AliasToStyleIdMap[key] === styleId) ||
  styleId

export const aliasToStyleId = (alias: string): string => AliasToStyleIdMap[alias] || alias

export const styleIdIsFootnote = (styleId: string) => footnoteStyleIds.has(styleId)

export const styleIdIsFootnoteAlias = (styleId: string) =>
  aliasFootnoteStyleIds.has(styleId)

export const isStyleFootnote = (styleId: string): boolean =>
  styleIdIsFootnoteAlias(styleId) || styleIdIsFootnote(styleId)

// We can extend this to APA when we are ready to implement APA7
export const transformDeprecatedStyleId = (styleId: string): string =>
  styleId === 'mla' ? 'mla9' : styleId

export const getActualStyleId = (style: string): string => {
  return urlStyleToIdMap[style] !== undefined ? urlStyleToIdMap[style] : style
}

export const getCapitalizedSEONameOfStyle = (urlStyle: string): string =>
  popularStyles[getActualStyleId(urlStyle)]?.[0].toUpperCase() ?? urlStyle.toUpperCase()

export const isStyleIdInValid = (style: string): boolean => {
  return !styleIdSet.has(style)
}

export const isStyleNonPrimary = (style: string): boolean => {
  return styleIdSet.has(style) && !primaryStyles.has(aliasToStyleId(style))
}

export const handleStylesResponses = (
  responses: any[]
): { resultStyles: []; styles: [] } => {
  let styles
  let resultStyles
  if (responses.length > 1) {
    const firstStylesV2 = responses[0].data.citationStylesV2.results
    const currentStylesV2 = responses[1].data.citationStylesV2.results
    styles = [...firstStylesV2]
    resultStyles = [...currentStylesV2]
  } else styles = [...responses[0].data.citationStylesV2.results]
  return { resultStyles, styles }
}

export const isStyleGated = (style: string, role: string) => {
  const userStyles = new UserStyles(role)
  const isCurrentStyleGated =
    style && !userStyles.isStyleAllowed(transformDeprecatedStyleId(style))
  const isModalGate = userStyles.isModalGate()
  return isCurrentStyleGated && isModalGate
}
